import envVar from '../config/envVars';
import { NewSchool } from '../modules/SchoolManagement/types/school';
import httpGet from './httpClient/httpGet';
import httpPost from './httpClient/httpPost';

const getSchools = async () => {
  return httpGet(`${envVar.REACT_APP_BASE_API_URL}/schools`);
};

const getSchoolByName = async (schoolName: string) => {
  return httpGet(`${envVar.REACT_APP_BASE_API_URL}/schools/${schoolName}`);
};

const saveSchool = async (data: NewSchool) => {
  return httpPost(`${envVar.REACT_APP_BASE_API_URL}/schools`, data);
};

const school = {
  getSchools,
  getSchoolByName,
  saveSchool
};

export default school;
